import React from 'react';
import classNames from 'classnames';
import moment from 'moment';

import './index.scss';

const ContentApprovalTimer = (props) => {
    const {dueDate} = props;

    if (!dueDate) return null;

    const reviewDueDate = moment(dueDate, 'YYYY-MM-DD HH:mm:ss')
        .utc()
        .zone('-08:00');

    const isOverdue =
        moment()
            .utc()
            .zone('-08:00')
            .format('YYYY-MM-DD HH:mm:ss') > reviewDueDate.format('YYYY-MM-DD HH:mm:ss');

    const duration = moment.duration(reviewDueDate.diff(moment()));
    const hours = Math.abs(parseInt(duration.asHours(), 10));
    const minutes = Math.abs(parseInt(duration.asMinutes(), 10) % 60);

    const timerMessaging = isOverdue
        ? {
              messageText: 'Overdue:',
              timeLeft: `${hours}h ${minutes}m`
          }
        : {
              messageText: 'Review by:',
              timeLeft: `${moment(dueDate)
                  .utc()
                  .zone('-08:00')
                  .format('MMM Do @ hA')} PT`
          };

    const timerClass = classNames('content-approval-timer', {
        'content-approval-timer__overdue': isOverdue,
        'content-approval-timer__pending': !isOverdue
    });

    const renderIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="14"
            viewBox="0 0 13 14"
            className="content-approval-timer__icon"
        >
            <g fill="none" fillRule="evenodd">
                <path fill="transparent" d="M-1188-589H252V902h-1440z" />
                <g transform="translate(-954 -42)">
                    <g>
                        <path
                            fill="currentColor"
                            fillRule="nonzero"
                            d="M965.088 46.064l.894-.895a.609.609 0 1 0-.86-.86l-.895.894a6.058 6.058 0 0 0-3.24-1.346v-.64h.608a.609.609 0 0 0 0-1.217h-2.435a.609.609 0 0 0 0 1.217h.61v.64a6.095 6.095 0 0 0-5.48 6.056A6.094 6.094 0 0 0 960.379 56a6.094 6.094 0 0 0 6.087-6.087c0-1.46-.518-2.8-1.377-3.85zm-2.865 4.458h-1.845a.609.609 0 0 1-.61-.609v-3.12a.609.609 0 0 1 1.218 0v2.511h1.237a.609.609 0 0 1 0 1.218z"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );

    return (
        <div className={timerClass}>
            {renderIcon()}
            <div className="content-approval-timer__message">
                {timerMessaging.messageText} {timerMessaging.timeLeft}
            </div>
        </div>
    );
};

export default ContentApprovalTimer;



// WEBPACK FOOTER //
// ./components/content_approval_timer/index.js